export enum ComponentId {
  IS_LEASE_CLIENT = "isLeasePlanClient",
  //VEHICLE_DRIVEABLE = "vehicleDriveable",
  OC_TYPE = "ocFormType",
}

export enum SectionId {
  WELCOME = "welcome",
  //AC_VEHICLE_DRIVEABLE = "welcome-ac-vehicle-driveable",
  OC_USER_INJURED = "welcome-oc-user-injured",
  OC_TYPE = "welcome-oc-type",
}
